import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Update Customer API Call
 * @param {Object} customerData - { id, first_name, last_name, mobile_no }
 * @returns {Promise<Object>} - Response data from the API
 */
export const updateCustomer = async (customerData) => {
  try {
    // Add the endpoint to agent/update_customer if not already in endpoints.js
    const response = await apiClient.post(
      API_ENDPOINTS.UPDATE_CUSTOMER.replace(":customerId", customerData.id),
      {
        first_name: customerData.first_name,
        last_name: customerData.last_name,
        mobile_no: customerData.mobile_no,
        mobile_country_code: customerData.mobile_country_code,
      }
    );

    return {
      success: true,
      data: response.data.data || response.data,
    };
  } catch (error) {
    handleApiError(error);
    return {
      success: false,
      message: error.message || "Failed to update customer",
    };
  }
};
